var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "custom-box",
    {
      attrs: {
        title: _vm.formData.id ? "修改球队" : "添加球队",
        visible: _vm.dialogFormVisible,
        modal: false,
        "modal-append-to-body": false
      },
      on: {
        "update:visible": function($event) {
          _vm.dialogFormVisible = $event
        },
        close: function($event) {
          return _vm.rewriteClearData()
        }
      }
    },
    [
      _c(
        "el-form",
        {
          ref: "ruleForm",
          staticClass: "popover",
          attrs: {
            rules: _vm.rules,
            model: _vm.formData,
            "label-width": "100px",
            "label-position": "left"
          }
        },
        [
          _c(
            "el-form-item",
            {
              staticClass: "lodingItem",
              attrs: { prop: "height", label: "身高" }
            },
            [
              _c("el-input", {
                staticClass: "flex-1",
                attrs: { autocomplete: "off", placeholder: "请输入" },
                model: {
                  value: _vm.formData.height,
                  callback: function($$v) {
                    _vm.$set(_vm.formData, "height", $$v)
                  },
                  expression: "formData.height"
                }
              })
            ],
            1
          ),
          _c(
            "el-form-item",
            {
              staticClass: "lodingItem",
              attrs: { prop: "weight", label: "体重" }
            },
            [
              _c("el-input", {
                staticClass: "flex-1",
                attrs: { autocomplete: "off", placeholder: "请输入" },
                model: {
                  value: _vm.formData.weight,
                  callback: function($$v) {
                    _vm.$set(_vm.formData, "weight", $$v)
                  },
                  expression: "formData.weight"
                }
              })
            ],
            1
          ),
          _c(
            "el-form-item",
            {
              staticClass: "lodingItem",
              staticStyle: { width: "100%" },
              attrs: { prop: "preferred_foot", label: "惯用脚" }
            },
            [
              _c(
                "el-radio-group",
                {
                  model: {
                    value: _vm.formData.preferred_foot,
                    callback: function($$v) {
                      _vm.$set(_vm.formData, "preferred_foot", $$v)
                    },
                    expression: "formData.preferred_foot"
                  }
                },
                [
                  _c("el-radio", { attrs: { label: "left", border: "" } }, [
                    _vm._v("左脚")
                  ]),
                  _c("el-radio", { attrs: { label: "right", border: "" } }, [
                    _vm._v("右脚")
                  ]),
                  _c("el-radio", { attrs: { label: "both", border: "" } }, [
                    _vm._v("双脚")
                  ])
                ],
                1
              )
            ],
            1
          ),
          _c(
            "el-form-item",
            {
              staticClass: "lodingItem",
              attrs: { prop: "jersey_number", label: "球衣号码" }
            },
            [
              _c("el-input", {
                staticClass: "flex-1",
                attrs: { autocomplete: "off", placeholder: "请输入" },
                model: {
                  value: _vm.formData.jersey_number,
                  callback: function($$v) {
                    _vm.$set(_vm.formData, "jersey_number", $$v)
                  },
                  expression: "formData.jersey_number"
                }
              })
            ],
            1
          ),
          _c(
            "el-form-item",
            {
              staticClass: "lodingItem",
              attrs: { prop: "position", label: "主力位置" }
            },
            [
              _c("el-input", {
                staticClass: "flex-1",
                attrs: { placeholder: "请填写", autocomplete: "off" },
                model: {
                  value: _vm.formData.position,
                  callback: function($$v) {
                    _vm.$set(_vm.formData, "position", $$v)
                  },
                  expression: "formData.position"
                }
              })
            ],
            1
          )
        ],
        1
      ),
      _c(
        "div",
        {
          staticClass: "dialog-footer",
          attrs: { slot: "footer" },
          slot: "footer"
        },
        [
          _c(
            "el-button",
            {
              staticStyle: { "margin-left": "200px" },
              attrs: { round: "" },
              on: {
                click: function($event) {
                  _vm.dialogFormVisible = false
                }
              }
            },
            [_vm._v("取消")]
          ),
          _c(
            "el-button",
            {
              attrs: { type: "primary", round: "" },
              on: {
                click: function($event) {
                  return _vm.dataFormSubmit()
                }
              }
            },
            [_vm._v("确定")]
          )
        ],
        1
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }